export default "__VITE_ASSET__$0l7zlZR__"